<template>
  <div style="width: 100%">
    <div
      style="
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-bottom: 16px;
        margin-right: -4px;
      "
    >
      <div class="data-table-buttons"></div>
    </div>
    <modal-product-novo
      :showNewModal="showNewModal"
      @modal-product-novo-dismiss="showNewModal = false"
      @modal-product-novo-action="formularioFoiAdicionado"
    />
    <modal-product-editar
      :showEditModal="showEditModal"
      :product="selectedItem"
      @modal-product-editar-dismiss="showEditModal = false"
      @modal-product-editar-action="formularioFoiEditado"
    />
    <modal-product-delete
      :showDeleteModal="showDeleteModal"
      :product="selectedItem"
      @modal-product-delete-dismiss="showDeleteModal = false"
      @modal-product-delete-action="produtoFoiExcluido"
    />
    <div class="row">
      <div class="col">
        <table
          width="100%"
          style="width: 100%"
          ref="datatable"
          class="display table-bordered nowrap display compact"
        >
          <thead>
            <tr v-if="columns">
              <th v-for="(column, index) in columns" :key="index"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="columns">
              <th v-for="(column, index) in columns" :key="index"></th>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from "@/components/Modal";
import ModalProductEditar from "@/components/ModalsProduct/ModalProductEditar";
import ModalProductDelete from "@/components/ModalsProduct/ModalProductDelete";
import ModalProductNovo from "@/components/ModalsProduct/ModalProductNovo";
var $ = require("jquery");
import JSZIP from "jszip";
window.JSZip = JSZIP;
import "datatables.net";
import "datatables.net-dt";
import "datatables.net-fixedcolumns-dt";
import pdfMake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import "datatables.net-buttons-dt";
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";
import { mapGetters } from "vuex";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  name: "data-table",
  props: ["columns", "data", "label"],
  data: () => {
    return {
      DataTable: null,
      showNewModal: false,
      showEditModal: false,
      showDeleteModal: false,
      selectedItem: null, //ITEM SEMPRE GUARDADO, PARA PASSAR PARA MODALS DE ACTIONS. {row: index, item: Object}
    };
  },
  components: {
    Modal,
    ModalProductEditar,
    ModalProductDelete,
    ModalProductNovo,
  },
  methods: {
    podeExibir() {
      let pode = true;
      pode = this.columns && this.columns.length ? pode : false;
      pode = this.data && this.data.length ? pode : false;
      return pode;
    },
    formularioFoiEditado({ row, item }) {
      this.DataTable.row(row).data(item).draw();
      this.showEditModal = false;
    },
    formularioFoiAdicionado(item) {
      this.DataTable.row.add(item).draw();
      this.showNewModal = false;
    },
    produtoFoiExcluido(row) {
      this.DataTable.row(row).remove().draw();
      this.showDeleteModal = false;
    },
  },
  mounted() {
    this.$root.$on("modal-product-novo", () => {
      this.showNewModal = true;
    });
  },
  computed: {
    ...mapGetters([
      "user"
    ]),
  },
  created() {
    const buttonsTitle = `Lista de ${this.label} de ${this.user.name}`;
    $(document).ready(() => {
      const DT = $(this.$refs.datatable).DataTable({
        scrollX: true,
        serverSide: true,
        processing: true,
        ajax: `${process.env.VUE_APP_API_CAKE_URL}datatables/products_list.php`,
        order: [[1, "asc"]],
        oLanguage: {
          sUrl:
            `${process.env.VUE_APP_API_CAKE_URL}panel/vendors/bower_components/datatables.net/lang/Portuguese-Brasil.json`,
        },
        // dom: 'Bfrtip',
        columns: this.columns,
        fixedColumns: {
          leftColumns: 1,
          rightColumns: 0,
        },
        columns: this.columns,
        buttons: [
          {
            extend: "print",
            text: " ",
            title: buttonsTitle,
            autoPrint: true,
            footer: true,
            header: true,
            customize: function (dom, bt, api) {
              $(dom.document).find("html").addClass("printMode");
              $(dom.document).find("body").addClass("printMode");
            },
          },
          {
            extend: "pdfHtml5",
            text: " ",
            title: buttonsTitle,
          },
          {
            extend: "excelHtml5",
            text: " ",
            title: buttonsTitle,
          },
        ],
        initComplete: () => {
          DT.buttons()
            .container()
            .prependTo(".data-table-buttons", DT.buttons().container());
          $(".data-table-buttons .dt-buttons .dt-button").each(function () {
            if ($(this).hasClass("buttons-print")) {
              $(this).attr("title", "Imprimir");
              $(this).html('<i class="el-icon-printer"></i>');
            } else if ($(this).hasClass("buttons-pdf")) {
              $(this).attr("title", "Gerar PDF");
              $(this).html('<i class="el-icon-document"></i>');
            } else if ($(this).hasClass("buttons-excel")) {
              $(this).attr("title", "Baixar como arquivo excel");
              $(this).html('<i class="el-icon-menu"></i>');
            }
          });

          $(document).on("click", "#data-table-acoes i", function () {
            const data = DT.rows($(this).parent()).data()[0];
            const rowIndex = DT.rows($(this).parent()).indexes()[0];
            Vue.selectedItem = { row: rowIndex, item: data };
            Vue.showEditModal = $(this).hasClass("el-icon-edit");
            Vue.showDeleteModal = $(this).hasClass("el-icon-delete");
          });
        },
      });
      this.DataTable = DT;
      const Vue = this;
      $(this.$refs.datatable)
        .children("tbody")
        .on("click", "tr", function (e) {
          if (
            $(e.target).attr("id") != "data-table-acoes" &&
            $(e.target).prop("tagName") != "I" &&
            !$(e.target).children("#data-table-acoes").length
          )
            var data = DT.row(this).data(); //PEGAR DADO DA LINHA
          if (data) {
            Vue.$emit("on-row-click", data);
          }
        });
    });
  },
};
</script>

<style >
@import "https://cdn.datatables.net/1.10.22/css/jquery.dataTables.min.css";
@import "https://cdn.datatables.net/v/dt/jszip-2.5.0/dt-1.10.23/b-1.6.5/b-html5-1.6.5/b-print-1.6.5/datatables.min.css";

th,
td {
  text-align: center;
  vertical-align: middle;
}

.dt-button {
  margin: 0 !important;
  padding: 0.5em !important;
  border: none !important;
  background: none !important;
  color: rgba(0, 0, 0, 0.4) !important;
}
.dt-button:hover {
  color: rgba(0, 0, 0, 0.9) !important;
}
.dt-button i {
  font-size: 2em;
}

#data-table-acoes {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  font-size: 1.1em;
}
#data-table-acoes i {
  cursor: pointer;
}
#data-table-acoes .el-icon-edit {
  color: #27ae60;
}
#data-table-acoes .el-icon-delete {
  color: #e74c3c;
}
</style>>

